module.exports = __webpack_public_path__ + "8fb988a11e6a53f2e3b1682b97737c04.jpg";